'use strict';

function toArray(collection) {
	return Array.prototype.slice.call(collection);
}

function grouping() {
	const groupOrigins = toArray(document.querySelectorAll('[class*="group-origin-"]'))
		.filter(element => !jQuery(element).parents('.no-group').length)
		.map(element => {
			let id = -1;

			for (let i = 0; i < element.classList.length; i++) {
				const match = element.classList[i].match(/group-origin-(\d+)/);
				if (match) {
					id = match[1];
					break;
				}
			}

			return { element, id };
		})
		.filter(item => item.id >= 0);
	const groupClients = toArray(document.querySelectorAll('[class*="group-client-"]'))
		.filter(element => !jQuery(element).parents('.no-group').length)
		.map(element => {
			let id = -1;

			for (let i = 0; i < element.classList.length; i++) {
				const match = element.classList[i].match(/group-client-(\d+)/);
				if (match) {
					id = match[1];
					break;
				}
			}

			return { element, id };
		})
		.filter(item => item.id >= 0);

	groupOrigins
		.map(item => {
			item.clients = groupClients
				.filter(client => client.id === item.id)
				.map(client => client.element);

			return item;
		})
		.forEach(group => {
			const reference = group.element;
			const parent = reference.parentElement;

			const groupElement = document.createElement('div');
			groupElement.classList.add('group');
			groupElement.classList.add(`group-id-${group.id}`);

			parent.insertBefore(groupElement, reference);
			groupElement.appendChild(reference);
			group.clients.forEach(client => groupElement.appendChild(client));
		});
}

function searchOverlay() {
	const overlayElement = document.querySelector('.overlay.overlay-search');
	const initiatorElement = document.querySelector('.overlay-initiator.search');
	const searchField = document.querySelector('.search-field');
	if (overlayElement && initiatorElement && searchField) {
		const closeElement = overlayElement.querySelector('.close');

		if (!overlayElement || !initiatorElement || !closeElement) return;
	
		function open() {
			if (overlayElement.classList.contains('inactive')) {
				overlayElement.classList.remove('inactive');
			}
			overlayElement.classList.add('active');
			searchField.focus();
		}
	
		function close() {
			if (overlayElement.classList.contains('active')) {
				overlayElement.classList.remove('active');
			}
			overlayElement.classList.add('inactive');
		}
	
		initiatorElement.addEventListener('click', open);
	
		closeElement.addEventListener('click', close);
	
		return { open, close };
	}
	 
}

function videoOverlay() {
	const overlayElement = document.querySelector('.overlay.overlay-video');
	if (overlayElement) {
		const initiatorElements = toArray(document.querySelectorAll('.overlay-initiator.video'));
		const iframeElement = overlayElement.querySelector('.iframe-container');
	const closeElement = overlayElement.querySelector('.close');
	const iframe = document.createElement('iframe');

	if (!overlayElement || !initiatorElements.length || !iframeElement || !closeElement) return;

	function open(iframeSrc) {
		if (overlayElement.classList.contains('inactive')) {
			overlayElement.classList.remove('inactive');
		}
		overlayElement.classList.add('active');
		iframe.src = iframeSrc;
		
		jQuery(iframeElement).append(iframe);
	}

	function close() {
		if (overlayElement.classList.contains('active')) {
			overlayElement.classList.remove('active');
		}
		overlayElement.classList.add('inactive');

		jQuery(iframe).remove();
	}


	initiatorElements.forEach(initiatorElement => {
		initiatorElement.addEventListener('click', event => {
			event.preventDefault();
			open(initiatorElement.getAttribute('href'));
		});
	});

	closeElement.addEventListener('click', close);

	return { open, close };
	}
	 
}

class StylizeSlider {
	constructor({ sliderElement }) {
		this.sliderElement = sliderElement;

		this.wrapper = document.createElement('div');
		this.wrapper.classList.add('stylized-slider');
		this.sliderElement.classList.remove('stylized-slider');

		this.valueElement = document.createElement('span');
		this.valueElement.classList.add('value');
		this.wrapper.appendChild(this.valueElement);

		this.sliderElement.parentElement.insertBefore(this.wrapper, sliderElement);
		this.wrapper.appendChild(this.sliderElement);

		this.sliderElement.addEventListener('input', () => this.changeHandler());

		this.changeHandler();
	}

	changeHandler() {
		const value = this.sliderElement.value;

		this.valueElement.textContent = value;
	}
}

function stylizeSliders() {
	const sliders = toArray(document.querySelectorAll('input[type="range"].stylized-slider'));

	sliders.forEach(sliderElement => {
		new StylizeSlider({ sliderElement });
	});
}

function sideMenu() {
	const toggleButton = document.querySelector('.menu-toggle-button');
	const sideMenu = document.querySelector('.side-menu-wrapper');

	if (!toggleButton || !sideMenu) return;

	let open = false;

	function openSideMenu() {
		open = true;
		sideMenu.classList.add('open');
	}

	function closeSideMenu() {
		open = false;
		sideMenu.classList.remove('open');
	}
	
	toggleButton.addEventListener('click', () => {
		if (open) {
			closeSideMenu();
		} else {
			openSideMenu();
		}
	});

	window.addEventListener('resize', () => {
		if (window.innerWidth > 700 && open) {
			closeSideMenu();
		}
	});
}

jQuery(document).ready(() => {
	// grouping();
	searchOverlay();
	videoOverlay();
	stylizeSliders();
	sideMenu();
});

jQuery(document).ready(function() {

	// Select all links with hashes
	jQuery('a[href*="#"]')
	// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
				&&
				location.hostname === this.hostname
			) {
				// Figure out element to scroll to
				var target = jQuery(this.hash);
				target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					jQuery('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function () {
						// Callback after animation
						// Must change focus!
						var $target = jQuery(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						}
						;
					});
				}
			}
		});
});



const maksimer = {
    attesterSlider: () => {

        const container = document.querySelector('.maksimer-attester-posts');
        if (!container) return;

        const wrap = container.querySelector('.maksimer-attester-posts-wrap');
        let slides = wrap.querySelectorAll('.maksimer-attester-post');
        console.log(slides.length);
        if (slides && slides.length < 3) {
            const nav = document.querySelectorAll('.maksimer-attester > a');
            [...nav].map(a => a.style.display = 'none');
            return;
        }
        const slide = wrap.querySelector('.maksimer-attester-post');
        let lastSlide = slides[slides.length - 1];

        wrap.style.width = slides.length * slide.offsetWidth + 'px';
        wrap.style.marginLeft = -slide.offsetWidth + 'px';
        wrap.insertBefore(lastSlide, wrap.firstChild);

    },
    attesterMovement: () => {
        let slides = document.querySelectorAll('.maksimer-attester-post');
        if (slides && slides.length < 3) {
            return;
        }
        const moveLeft = (slide) => {
            jQuery('.maksimer-attester-posts-wrap').animate({
                left: +slide.offsetWidth
            }, 200, function() {
                jQuery('.maksimer-attester-posts > div > div:last-child').prependTo('.maksimer-attester-posts > div');
                jQuery('.maksimer-attester-posts > div').css('left', '');
            });
        };
        const moveRight = (slide) => {
            jQuery('.maksimer-attester-posts-wrap').animate({
                left: -slide.offsetWidth
            }, 200, function() {
                jQuery('.maksimer-attester-posts > div > div:first-child').appendTo('.maksimer-attester-posts > div');
                jQuery('.maksimer-attester-posts > div').css('left', '');
            });
        };
        const prev = document.querySelector('.maksimer-attester-nav-prev');
        if (prev) {
            prev.addEventListener('click', (e) => {
                e.preventDefault();
                moveLeft(document.querySelector('.maksimer-attester-post'));
            });
        }
        const next = document.querySelector('.maksimer-attester-nav-next');
        if (next) {
            next.addEventListener('click', (e) => {
                e.preventDefault();
                moveRight(document.querySelector('.maksimer-attester-post'));
            });
        }
    },
    postAuthorDescriptionLimit: () => {
        const container = document.querySelector('.maksimer-author-desc.--limit');
        if (container) {
            const link = container.querySelector('.maksimer-author-read-more');
            if (link) {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    link.parentNode.classList.remove('--limit');
                });
            }
        }
    }
}

jQuery(document).ready(function() {
	maksimer.attesterMovement()
	maksimer.attesterSlider();
	maksimer.postAuthorDescriptionLimit();

	window.addEventListener('resize', () => {
		maksimer.attesterSlider();
	});
});

const maksimerPopupRecurrence = () => {
	const popupId = 21176;
	const recuringTime = localStorage.getItem('maksimer_newsletter_popup_recurring');
	if (!recuringTime) {
		return;
	}

	const closedTime = localStorage.getItem('maksimer_newsletter_closed');
	jQuery(document).on('elementor/popup/hide', (event, id, instance) => {
		if (id === popupId) {
			localStorage.setItem('maksimer_newsletter_closed', new Date());
		}
	});

	// console.log(new Date());
	// console.log(
	// 	new Date(new Date().setDate(new Date(closedTime).getDate() + parseInt(recuringTime)))
	// );
	// console.log(new Date() >= new Date(new Date().setDate(new Date(closedTime).getDate() + parseInt(recuringTime))));
	
	if (new Date() >= new Date(new Date().setDate(new Date(closedTime).getDate() + parseInt(recuringTime)))) {
		elementorProFrontend.modules.popup.showPopup( { id: popupId } );
		console.log('elementor popup triggered');
	}
}

if (!localStorage.getItem('maksimer_newsletter_closed')) {
	if (localStorage.getItem('elementor')) {
		localStorage.removeItem('elementor');
		console.log('elementor storage item removed');
	}
}
jQuery(window).on('load', ()=> {
	maksimerPopupRecurrence();
});

/**
 * Autofocus on search modal input when clicked on search icon.
 */
const maksimerSearchAutofocust = () => {
	document.addEventListener('click', (e) => {
		const searchIcon = document.querySelector('.maksimer-search-icon');
		if (!searchIcon) {
			return;
		}
		if (searchIcon === e.target || searchIcon.contains(e.target)) {
			setTimeout(function(){
				const input = document.querySelector('.elementor-search-form__input');
				input.focus();
				input.setSelectionRange(0, input.value.length);
			}, 500);
			 
		}
	});
}

maksimerSearchAutofocust();
